import React from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import DistributionByContractType from "./DistributionByContractType";
import RecentlyFlagged from "./RecentlyFlagged";
import Header from "./Header";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const AgencyDashboard = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Agency Dashboard");

  document.title = "Agency Dashboard | CIMS";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="">
          <Header />
          <Row className="mt-5">
            <Col lg={12}>
              <Row>
                <Widget />
              </Row>
            </Col>
          </Row>
          <Row>
            <RecentlyFlagged />
            <DistributionByContractType />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AgencyDashboard;
